import React from 'react'
import OurServices from './services copy 6'
import { useContext } from 'react'
import NoteContext from '../context/notes/noteContext'
import Projects from './services copy 7'
import { Link } from 'react-router-dom'
export default function OurWork(params) {
    const context = useContext(NoteContext)
    const { setBars,setBackgroundColor } = context
    setBars('grey-bars')
    setBackgroundColor('black')
    return (
        <div>
            <div className="">
                <div className="">
                    <div style={{ backgroundColor: '#f8f9f9' }}>
                        <div className="container px-4 py-5">
                            <div className="d-flex justify-content-between">
                                <h1 className='serviceheading really-bold'>PROJECTS</h1>
                                <button style={{ borderRadius: '0px', backgroundColor: "#A10302", color: 'white', height: 'max-content' }} className="btn">GET IN TOUCH</button>
                            </div>
                        </div>
                    </div>
                   
                    <div className="container">
                        <div className="d-flex mt-5">

                            <ul className="navbar-nav me-auto mb-2 mb-lg-0 d-flex">
                                <div className="d-flex flex-wrap">
                                    <li className=" nav-item">
                                        <a href="#" style={{ color: '#A10302', fontFamily: 'Montserrat' }} className="nav-link mx-3" aria-current="page" >All Projects</a>
                                    </li>


                                    <li className=" nav-item">
                                        <a href="#interiordesign" style={{ color: '#A10302', fontFamily: 'Montserrat' }} className="nav-link mx-3">Interior Design</a>
                                    </li>

                                    <li className=" nav-item">
                                        <a href="#education" style={{ color: '#A10302', fontFamily: 'Montserrat' }} className="nav-link mx-3" >Eduation</a>
                                    </li>

                                    <li className="nav-item">
                                        <a href="#greenbuilding" style={{ color: '#A10302', fontFamily: 'Montserrat' }} className="nav-link mx-3" >Green Building</a>
                                    </li>
                                    <li className="nav-item">
                                        <a href="#healthcare" style={{ color: '#A10302', fontFamily: 'Montserrat' }} className="nav-link mx-3" >Health Care</a>
                                    </li>
                                    <li className="nav-item">
                                        <a href="#office" style={{ color: '#A10302', fontFamily: 'Montserrat' }} className="nav-link mx-3" >Office</a>
                                    </li>
                                </div>

                            </ul>
                        </div>
                        <div className='mb-5'>
                            <Projects />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/servicesMain copy.jsx